import { Box, Text } from '@mantine/core';
import { useProtocolInfo } from 'src/api';
import {
  STATUSPAGE_LINK,
  ALWAYS_SHOW_STAKING_STATUS_BANNER,
} from 'src/constants';

const statusMessage = import.meta.env.VITE_STAKING_STATUS_BANNER_MESSAGE;

export function StakingStatusBanner() {
  const { protocolInfoError } = useProtocolInfo();

  if (protocolInfoError || ALWAYS_SHOW_STAKING_STATUS_BANNER) {
    return (
      <Box className="w-[544px] max-w-full mx-auto rounded-[16px] p-4 mb-4">
        <Text className="text-pretty whitespace-pre-line">
          {statusMessage ||
            'Withdrawals/Protocol Stats may be unavailable for some users.'}
          <br />
          <a
            href={STATUSPAGE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline"
          >
            Learn more.
          </a>
        </Text>
      </Box>
    );
  }

  return null;
}
